/**
 * Contact email published on the legal pages (mentions légales, privacy
 * policy, cookie policy). It is the address data subjects use to exercise
 * their GDPR rights, so it must point at a monitored inbox. Import this
 * constant rather than hardcoding the address.
 */
export const CONTACT_EMAIL = 'contact@balivernologie.info'
